import React, { useState } from "react";
import PinInput from "react-pin-input";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { get_root_value } from "src/utils/domUtils";

export default function PinCodeForm({ onhandlePinCodeSubmit }) {
  const [pinCode, setPinCode] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!pinCode) {
      return;
    }
    onhandlePinCodeSubmit(pinCode);
  };

  return (
    <form autoComplete="off" noValidate onSubmit={handleSubmit}>
      <Stack spacing={3}>
        <PinInput
          length={6}
          initialValue=""
          secret={false}
          onChange={(value, index) => setPinCode(value)}
          type="numeric"
          inputMode="number"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
          inputStyle={{ borderColor: "red", color: "white" }}
          inputFocusStyle={{
            borderColor: get_root_value("--portal-theme-primary"),
          }}
          onComplete={(value, index) => {}}
        />
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ my: 2 }}
      >
        <LoadingButton
          className="small-contained-button"
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          Submit
        </LoadingButton>
      </Stack>
    </form>
  );
}
